import { type IEvaluationVariables } from '../../evaluate/variables/IEvaluationVariables.ts';
import { ExpressionType } from '../../IExpression.ts';
import { type IAsyncService } from './context/IAsyncService.ts';
import { type IAsyncServiceInputConfig } from './useAsyncServiceFetch.ts';

/**
 * Costruisce i parametri/dati da passare in input al servizio asincrono
 */
export function buildAsyncServiceParams(
  service: IAsyncService,
  inputs: IAsyncServiceInputConfig,
  variables: IEvaluationVariables,
): Record<string, string | number> {
  const params = {} as any;

  for (const input of service.inputs) {
    const expression = inputs[input.name];
    if (!expression) break;
    if (
      expression.type === ExpressionType.Value &&
      // Utilizziamo un controllo più stringente per evitare
      // che valori come 0 o false vengano scartati
      expression.value != null &&
      expression.value !== ''
    ) {
      params[input.name] = expression.value;
    }
    if (expression.type === ExpressionType.Reference && expression.value.id) {
      params[input.name] = variables[expression.value.id];
    }
  }

  return params;
}
